import { render } from "./FooterPage.vue?vue&type=template&id=193e23ed"
const script = {}

import "./FooterPage.vue?vue&type=style&index=0&id=193e23ed&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__